import { axios } from '@/vue/utils/request'

const api = {
  //表单
  formData:'/formModule/formData',
  //任务
  getAssignmentList: '/fore/assignment/list',
  //保存任务
  saveAssignment: '/fore/assignment/save',
  //保存子记录
  saveAssignTask: '/fore/assignTask/save',
  // 获取子记录列表
  getAssignTaskList: '/fore/assignTask/list',
  //上家信息
  upperBank:  '/upper/info',
  //下家信息
  downBank: '/down/info',

}


export function saveFormData(params) {
    return axios({
        url: api.formData,
        method: 'post',
        data: params
    })
}

export function getFormData(params) {
    return axios({
        url: api.formData,
        method: 'get',
        params: params
    })
}

export function getAssignmentList(params) {
    return axios({
        url: api.getAssignmentList,
        method: 'get',
        params: params
    })
}

export function saveAssignment(params) {
    return axios({
        url: api.saveAssignment,
        method: 'post',
        data: params
    })
}

export function saveAssignTask (parameter) {
    return axios({
        url: api.saveAssignTask,
        method: 'post',
        data: parameter
    })
}

export function getAssignTaskList (parameter) {
    return axios({
        url: api.getAssignTaskList,
        method: 'get',
        params: parameter
    })
}

//上家信息保存
export function saveUpperBank (params) {
    return axios({
        url: api.upperBank,
        method: 'post',
        data: params,
    })
}
//上家信息查找
export function findUpperBank (params) {
    return axios({
        url: api.upperBank,
        method: 'get',
        params: params,
    })
}

//下家信息保存
export function saveDownBank (params) {
    return axios({
        url: api.downBank,
        method: 'post',
        data: params,
    })
}
//下家信息查找
export function findDownBank (params) {
    return axios({
        url: api.downBank,
        method: 'get',
        params: params,
    })
}